import { jsxs, jsx } from 'react/jsx-runtime';
import { fieldsetStyle } from '../styles.js';
var StubbedDismissActions = function StubbedDismissActions(_ref) {
  var onCancel = _ref.onCancel,
    onEscape = _ref.onEscape;
  return jsxs("fieldset", {
    style: fieldsetStyle,
    children: [jsx("legend", {
      children: "Stubbed dismiss options"
    }), jsx("button", {
      onClick: onCancel,
      children: "Cancel"
    }), jsx("button", {
      onClick: onEscape,
      children: "Escape"
    })]
  });
};
export { StubbedDismissActions as default };